export enum EMSP_KEYS {
  EMSP_CHECKOUT_CONSENT = 'EMSP_CONSENT',
  EMSP_PAYMENT_CONSENT = 'EMSP_PAYMENT_CONSENT',
  EMSP_SWITCH_PAYMENT_DISCLAIMER = 'EMSP_SWITCH_PAYMENT_DISCLAIMER'
}
